import { AgentServiceHandler } from './agent.service.handler';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FieldItem } from 'src/app/models/common/field-item';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Injectable()
export class AgentService extends AgentServiceHandler {
  userType: any;

  getOutputPreferences(ref_id: any) {
    throw new Error('Method not implemented.');
  }
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }

  getBranchCode(item: FieldItem): void {
    let branchName = item.model.agentDetailDOField7;
    let branchCode: any;
    let body = {
      onlineLookupKey: 'BRANCHCODE',
      onlineFilterCond: {
        'intHieDO.branchName': branchName,
      },
      offlineLookupKey: 'BRANCHCODE',
      offlineFilterCond: {
        branchName: branchName,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        branchCode = JSON.parse(JSON.stringify(body));
        if (branchCode.data.values.length > 0) {
          item.model.branchId = branchCode.data.values.length > 0 ? branchCode.data.values[0].cd : null;
          //  this.setItemOptions(item, branchCode.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getSourceName(item: FieldItem): void {
    let sourceName = item.model.agentDetailDOField2;
    let sourceNum: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': sourceName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        sourceName: sourceName,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        sourceNum = JSON.parse(JSON.stringify(body));
        if (sourceNum.data.values.length > 0) {
          item.model.agentDetailDOField10 = sourceNum.data.values.length > 0 ? sourceNum.data.values[0].cd : null;
          //  this.setItemOptions(item, branchCode.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getReferenceName(item: FieldItem): void {
    let referName = item.model.agentDetailDOField3;
    let referNum: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': referName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        referName: referName,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        referNum = JSON.parse(JSON.stringify(body));
        if (referNum.data.values.length > 0) {
          item.model.agentDetailDOField11 = referNum.data.values.length > 0 ? referNum.data.values[0].cd : null;
          //  this.setItemOptions(item, branchCode.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }
  getReportingName(item: FieldItem): void {
    let reportName = item.model.agentDetailDOField4;
    let reportNum: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': reportName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        reportName: reportName,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        reportNum = JSON.parse(JSON.stringify(body));
        if (reportNum.data.values.length > 0) {
          item.model.agentDetailDOField12 = reportNum.data.values.length > 0 ? reportNum.data.values[0].cd : null;
          //  this.setItemOptions(item, branchCode.data.values);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  getReportBranchCode(item: FieldItem): void {
    let ReportName = item.model.agentDetailDOField4;
    let branchCodeFromReport: any;
    let body = {
      onlineLookupKey: 'EMPLOYEEHIERARCHY',
      onlineFilterCond: {
        'hierarchyDO.employeeCode': ReportName,
      },
      offlineLookupKey: 'EMPLOYEEHIERARCHY',
      offlineFilterCond: {
        ReportName: ReportName,
      },
    };
    this.httpPost(`${this.getURLValue('LOOKUP')}/loadLookupData`, body, undefined, false).subscribe(
      (body) => {
        branchCodeFromReport = JSON.parse(JSON.stringify(body));
        if (branchCodeFromReport.data.values.length > 0) {
          item.model.branchId =
            branchCodeFromReport.data.values.length > 0 ? branchCodeFromReport.data.values[0].desc : null;
          // item.model.branchId = '008';
          setTimeout(() => {
            this.getBranchName(item);
          }, 500);
        } else {
          setTimeout(() => {
            this.getBranchName(item);
          }, 500);
        }
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }

  sendEmail(applicationNumber) {
    let body = {
      applicationNum: applicationNumber,
    };
    let path = this.getURLValue('AGENT');
    return this.httpPost(`${path}/sendEmail`, body);
  }
  checkForDuplicateMobileNo(mobileNumber) {
    let body = {
      mobileNum: mobileNumber,
    };
    let path = this.getURLValue('AGENTLGI');
    return this.httpPost(`${path}/checkDuplicateMobileNo`, body);
  }
}
